module.exports = __webpack_public_path__ + "img/awb.71e1cbe2.png";